import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/stickyMenu.js";

function StickyMenu() {
    useEffect(() => {
        window.addEventListener("scroll", () => {
            const stickyMenu = document.querySelector(".sticky-menu");

            if (window.scrollY > 160) {
                stickyMenu.classList.add("sticky");
            } else {
                stickyMenu.classList.remove("sticky");
            }
        });
    });

    return (
        <Styles>
            {/* Sticky Menu */}
            <section className="sticky-menu">
                <Container>
                    <Row>
                        <Col md="3">
                            <div className="logo">
                                <NavLink to={process.env.PUBLIC_URL + "/"}>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/cozy_logo_3.svg"} alt="Cozy Couture Logo" />
                                </NavLink>
                            </div>
                        </Col>
                        <Col md="9">
                            <div className="menu-box d-flex justify-content-end">
                                <ul className="nav menu-nav">
                                    <li className="nav-item">
                                        <NavLink exact activeClassName="active" className="nav-link" to={process.env.PUBLIC_URL + "/"}>
                                            Home
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink activeClassName="active" className="nav-link" to={process.env.PUBLIC_URL + "/about"}>
                                            About
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink
                                            activeClassName="active"
                                            className="nav-link"
                                            to={process.env.PUBLIC_URL + "/product-category"}
                                            isActive={(match, location) => {
                                                return location.pathname.includes("product");
                                            }}
                                        >
                                            Products
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink activeClassName="active" className="nav-link" to={process.env.PUBLIC_URL + "/services"}>
                                            Services
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink activeClassName="active" className="nav-link" to={process.env.PUBLIC_URL + "/clients"}>
                                            Clients
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink activeClassName="active" className="nav-link" to={process.env.PUBLIC_URL + "/contact"}>
                                            Contact
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default StickyMenu;
